import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'rc-tooltip/assets/bootstrap.css';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import 'src/index.css';
import history from 'src/redux/history';
import App from 'src/App';
import store from 'src/redux/store/configureStore';

// react-query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

render(
  <Provider store={store()}>
    <ConnectedRouter history={history}>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <App history={history} />
      </QueryClientProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
